const pathJoin = (...paths: string[]): string =>
  paths
    .join('/')
    // replace recurring // due to joining with single /
    .replace(/(\/)+/gi, '/')
    // fix https:/ -> https:// because of last step
    .replace(/:\//g, '://');

export default pathJoin;
